import { render, staticRenderFns } from "./BillableTariff.vue?vue&type=template&id=ad70a094&scoped=true"
import script from "./BillableTariff.vue?vue&type=script&lang=js"
export * from "./BillableTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad70a094",
  null
  
)

export default component.exports